import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useForm } from "react-hook-form";
import styles from "./Products.module.sass";
import Select from "react-select";
import PropTypes from 'prop-types';

const ProductsDropdown = ({ cartId, cartItemsQuantity, checkoutPath }) => {
  const [selected, setSelected] = useState("");
  const [team, setTeam] = useState([]);
  const [isValid, setIsValid] = useState(false);
  const [cartItemsQuantityState, setCartItemsQuantityState] = useState(cartItemsQuantity);
  const [ItemSize, setItemSize] = useState("");
  const [Attachment, setAttachment] = useState(null);
  const [SchoolLogo, setSchoolLogo] = useState(null);
  const [Notes, setNotes] = useState("");
  const [DelDate, setDelDate] = useState("");
  const [ItemType, setItemType] = useState("");
  const [loading, setLoading] = useState(false);

  const { register, handleSubmit, setValue, formState: { errors, isValid: formIsValid } } = useForm({
    shouldUseNativeValidation: true,
  });

  useEffect(() => {
    setIsValid(ItemSize !== "Select");
  }, [ItemSize]);

  useEffect(() => {
    const url = new URL(window.location);
    url.searchParams.set('cart_id', cartId);
    window.history.pushState({}, '', url);
  }, [cartId]);

  const fetchProducts = (productTypeId) => {
    axios.get(`/api/v2/products?product_type_id=${productTypeId}`)
      .then(res => setTeam(res.data))
      .catch(error => console.error("There was an error fetching the products!", error));
  };

  const changeSelectOptionHandler = (event) => {
    const value = event.value;
    setSelected(value);
    setItemType(value);

    const productTypeMap = {
      "Banner": 3,
      "Event Tickets": 6,
      "Good Job Ticket Pads": 8,
      "Flyers": 2,
      "Notepads": 7,
      "Posters": 16,
      "Miscellaneous": 1,
    };

    fetchProducts(productTypeMap[value] || 99);
  };

  const handleDelDateChange = (e) => {
    const value = e.target.value;
    setDelDate(value);
    setValue("itemdate", value, { shouldValidate: true }); // Update the form state and trigger validation
  };

  const onSubmit = async (data, event) => {
    event.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append('cart_id', cartId);
    formData.append('Quantity', data.quantity);
    formData.append('ItemType', ItemType);
    formData.append('ItemSize', data.item_size);
    formData.append('Attachment', Attachment);
    formData.append('SchoolLogo', SchoolLogo);
    formData.append('ConfirmInput', data.confirmationinput);
    formData.append('DelDate', data.itemdate);
    formData.append('Notes', data.notes);
    formData.append('Price', ItemSize.split('$')[1]);
    formData.append('Format', ItemSize.split('$')[0]);

    // axios.post(`/api/v2/products/add_custom_item`, formData)
    //   .then(response => {
    //     const { cart_items_quantity } = response.data;
    //     if (cart_items_quantity !== undefined) {
    //       setCartItemsQuantityState(cart_items_quantity);
    //     }
    //   })
    //   .catch(error => console.error("There was an error adding the custom item!", error));

    try {
      const response = await axios.post('/api/v2/products/add_custom_item', formData);
      const { cart_items_quantity } = response.data;
      if (cart_items_quantity !== undefined) {
        setCartItemsQuantityState(cart_items_quantity);
      }
    } catch (error) {
      console.error("There was an error adding the custom item!", error);
    } finally {
      setLoading(false);
    }
  };

  const options2 = [
    { value: "Banner", label: "Banner" },
    { value: "Event Tickets", label: "Event Tickets" },
    { value: "Flyers", label: "Flyers" },
    { value: "Good Job Ticket Pads", label: "Good Job Ticket Pads" },
    { value: "Notepads", label: "Notepads" },
    { value: "Posters", label: "Posters" },
    { value: "Miscellaneous", label: "Miscellaneous" }
  ];

  return (
    <div className="container">
      <div className="row">
        <div className="col-sm-4 col-sm-offset-8 well cart-well">
          <span>Your Cart</span>
          <span className="glyphicon glyphicon-shopping-cart" aria-hidden="true"></span>
          (<span id="cart_quantity">{cartItemsQuantityState}</span>)
          <br />
          {cartItemsQuantityState > 0 && (
            <a href={checkoutPath} className="checkout">Checkout</a>
          )}
        </div>
      </div>

      <div className="row">
        <div className="hidden-xs col-sm-6">
          <img src="../../../assets/777999_Custom_Design.jpg" alt="Custom Design" className="" style={{ width: '100%', objectFit: 'cover' }} />
        </div>

        <div className="col-xs-12 col-sm-6">
          <form onSubmit={(event) => handleSubmit(onSubmit)(event)}>
            <h2>Custom Design Request</h2>
            <input type="hidden" {...register("cart_id")} value={cartId} />

            <label className={styles.label}>Item Type:</label><br />
            <Select
              options={options2}
              onChange={changeSelectOptionHandler}
              value={options2.find(option => option.value === ItemType)}
              label="Single select"
              placeholder={"Select "}
              menuPlacement="top"
              required
            />

            <br /><label className={styles.label}>Choose Size:</label><br />
            <select {...register("item_size")} placeholder={"Select "} style={{ padding: 10 }} onChange={(e) => setItemSize(e.target.value)}>
              <option value='1'>Select</option>
              {team.map((obj) => (
                <option key={obj.id} value={obj.name + ' $' + obj.price}>{obj.name} ${obj.price}</option>
              ))}
            </select>

            <br /><label className={styles.label}>Quantity:</label><br />
            <input type="number" min="1" max="1000" defaultValue="1" {...register("quantity", { required: "Please enter a quantity." })} />

            <br /><label className={styles.label}>Describe your project:</label><br />
            <label className={styles.p}>Provide the wording for your item, and any special requests or instructions.</label>
            <textarea {...register("notes")} rows="2" onChange={(e) => setNotes(e.target.value)}></textarea>

            <br /><label className={styles.label}>Image File Attachment</label><br />
            <input type="file" {...register("school_logo")} onChange={(e) => setSchoolLogo(e.target.files[0])} />

            <br /><label className={styles.label}>Other File Attachment</label><br />
            <input type="file" {...register("attachment")} onChange={(e) => setAttachment(e.target.files[0])} />

            <br />

            <div className={`form-group ${errors.itemdate ? 'has-error' : ''}`}>
              <div className="row">
                <div className="col-sm-5">
                  <label className="control-label"><strong>Desired Delivery Date:</strong></label>
                  <input type="date" className="form-control" {...register("itemdate", { required: "Please enter your desired delivery date." })} onChange={handleDelDateChange} />
                </div>
              </div>
              {errors.itemdate && <p className="help-block">{errors.itemdate.message}</p>}
              <p className="help-block">Please provide us with at least 7-10 business days to create your item(s).<br/>Shipping & delivery times vary.</p>
            </div>


            <div className="checkbox">
              <label>
                <input type="checkbox" {...register("confirmationinput")} value="1" />
                I would like to receive a quote before production begins.
              </label>
            </div>

            <div className="form-group">
              <button type="submit" className="btn btn-primary btn-lg" disabled={loading || !isValid} style={{ display: 'inline-flex', alignItems: 'center' }}>
                {loading ? (
                  <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" style={{ marginRight: '8px', width: '20px' }}>
                      <radialGradient id="a11" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)"><stop offset="0" stop-color="#FFFFFF"></stop><stop offset=".3" stop-color="#FFFFFF" stop-opacity=".9"></stop><stop offset=".6" stop-color="#FFFFFF" stop-opacity=".6"></stop><stop offset=".8" stop-color="#FFFFFF" stop-opacity=".3"></stop><stop offset="1" stop-color="#FFFFFF" stop-opacity="0"></stop></radialGradient><circle transform-origin="center" fill="none" stroke="url(#a11)" stroke-width="20" stroke-linecap="round" stroke-dasharray="200 1000" stroke-dashoffset="0" cx="100" cy="100" r="70"><animateTransform type="rotate" attributeName="transform" calcMode="spline" dur="1.1" values="360;0" keyTimes="0;1" keySplines="0 0 1 1" repeatCount="indefinite"></animateTransform></circle><circle transform-origin="center" fill="none" opacity=".2" stroke="#FFFFFF" stroke-width="20" stroke-linecap="round" cx="100" cy="100" r="70"></circle>
                    </svg>
                    Submitting...
                  </span>
                ) : (
                  <span>Add to Cart</span>
                )}
              </button>

              <a className="btn btn-info" href={`cart/${cartId}/quantity`} disabled={loading} style={{ marginLeft: '15px' }}>
                Checkout
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

ProductsDropdown.propTypes = {
  cartId: PropTypes.string.isRequired,
  cartItemsQuantity: PropTypes.number.isRequired,
  checkoutPath: PropTypes.string.isRequired,
};

export default ProductsDropdown;
